import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CancelShippingOrderForm";
import {cancelCancelShippingOrder} from "../../actions/ShippingApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values, props) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class CancelShippingOrderFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      reason: values.get("reason")
    }
    return this.props.cancelShippingOrder(updatedValues)
      .then((response) => {
        let serverErrors = response.data.cancelShippingOrder.errors;
        if (serverErrors.length <= 0) {
          this.props.cancelCancelShippingOrder();
        } else {
          // A cancellation can be refused because the sales order still owns the
          // stock reserved for the shipment. That explanation is keyed to a field
          // this form does not have, so show it as the form error rather than the
          // generic fallback.
          let message = serverErrors.map((error) => error.message).join(" ");
          let errors = createValidationErrors(serverErrors, message || "An error occured");
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCancelShippingOrder();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        message="Are you sure you want to cancel this order? This action cannot be undone. If order has already gone to packaging, a cancellation EDI messages will be sent to the warehouse."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CANCEL_SHIPPING_ORDER = gql`
  mutation cancelShippingOrder($data: CancelShippingOrderInput!) {
    cancelShippingOrder(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CANCEL_SHIPPING_ORDER, {
    props: ({ mutate }) => ({
      cancelShippingOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelCancelShippingOrder})(withMutation(CancelShippingOrderFormContainer));